import React, { useEffect, useState, useCallback, useRef } from "react";
import "./style.css";
import { TbLanguageHiragana } from "react-icons/tb";

const PLUGIN_DROPDOWN_CONTAINER_ID = "bhashiniLanguageDropdown";
const PLUGIN_OUTER_CONTAINER_CLASS = ".bhashini-plugin-container";

const LANGUAGE_OPTION_CLASS = ".language-option";

function LanguageTranslator() {
  const [pluginLoaded, setPluginLoaded] = useState(false);
  const loadingCheckInterval = useRef(null);
  const [currentLang, setCurrentLang] = useState(
    localStorage.getItem("lang") || "en"
  );
  const triggerTranslation = useCallback(() => {
    const confirmSwitch = window.confirm(
      `This will lead you to ${
        currentLang === "en" ? "हिंदी" : "English"
      } language. Are you sure to switch to this language?`
    );
    if (!confirmSwitch) return;
    const langCode = currentLang === "en" ? "hi" : "en";
    // 1. Find the specific language option element using its data-value attribute
    const selector = `${PLUGIN_DROPDOWN_CONTAINER_ID} ${LANGUAGE_OPTION_CLASS}[data-value="${langCode}"]`;
    const targetElement = document.querySelector(
      `#${selector.replace("#", "")}`
    );

    if (targetElement) {
      document.body.classList.add("translating");
      targetElement.click();
      console.log(` Translation successfully triggered for: ${langCode}`);
      localStorage.setItem("lang", langCode);
      document.querySelectorAll(".custom-lang-btn");
      setCurrentLang(langCode);
      document.body.classList.remove("translating");
      // .forEach((btn) => btn.classList.remove("active"));
      // document.getElementById(`btn-${langCode}`).classList.add("active");
    } else {
      console.error(
        `Error: Plugin language option for ${langCode} not found using selector: ${selector}`
      );
    }
  }, [currentLang]);

  //Check for the presence of the Bhashini dropdown container ID.
  const checkPluginLoad = () => {
    const dropdownContainer = document.getElementById(
      PLUGIN_DROPDOWN_CONTAINER_ID
    );
    const outerContainer = document.querySelector(PLUGIN_OUTER_CONTAINER_CLASS);

    if (dropdownContainer && outerContainer) {
      clearInterval(loadingCheckInterval.current); // Stop checking once found
      setPluginLoaded(true);

      // Hide the entire original plugin container
      outerContainer.style.display = "none";
      console.log(" Bhashini Plugin has loaded and its native UI is hidden.");
    } else {
      console.log(" Waiting for Bhashini plugin to load...");
    }
  };

  // Lifecycle Hook to continuously check for the plugin until found
  useEffect(() => {
    loadingCheckInterval.current = setInterval(checkPluginLoad, 500);

    return () => {
      clearInterval(loadingCheckInterval.current);
    };
  }, []);

  return (
    <div
      className="bhashini-custom-switcher-wrapper translate_btn"
      onClick={triggerTranslation}
      disabled={!pluginLoaded}
    >
      <div className="language-selector-bar">
        {/*custom buttons */}
        <button className="custom-lang-btn">
          <TbLanguageHiragana /> {currentLang === "en" ? "हिंदी" : "English"}
        </button>
      </div>
    </div>
  );
}

export default LanguageTranslator;
